import { DynamicIcon } from '@natu/ui/DynamicIcon';

import { type SBProps, sbEditable } from '../../../../utils';
import { BeforeAfterItem } from './BeforeAfterItem';

interface SBBeforeAfterProps {
  beforeHeader?: string;
  beforeText?: string;
  afterHeader?: string;
  afterText?: string;
}

export const SBBeforeAfter = ({ blok }: SBProps<SBBeforeAfterProps>) => {
  const { beforeHeader, beforeText, afterHeader, afterText } = blok;

  return (
    <section className="@container">
      <div
        className="@lg:flex-row @lg:gap-10 @4xl:gap-24 flex flex-col items-center gap-4"
        {...sbEditable(blok)}
      >
        <BeforeAfterItem header={beforeHeader} text={beforeText} />
        <DynamicIcon
          className="text-primary-600 @lg:w-[60px] @lg:min-w-[60px] @lg:rotate-[-90deg] w-[72px]"
          icon="arrowCircle"
        />
        <BeforeAfterItem header={afterHeader} text={afterText} color="primary" />
      </div>
    </section>
  );
};
